/* eslint-disable */
import { styled, Container, Box, useTheme, CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { memo, useEffect, useMemo, useContext, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import Sidebar from "../NavBar/sidebar/Sidebar";
import { Header } from "../NavBar/header/Header";
import Navigation from "../horizontallayout/navbar/Navigation";
import Customizer from "../customizer/Customizer";
import HorizontalHeader from "../horizontallayout/header/Header";
import { deleteSession, recoverSession, removeToken } from "../../utils/session";
import { TOKENBYUSER } from "../../gql/queries/users";
import { loginUser, setThemeConfig } from "../../redux/action";
import { useApolloContext } from "../../apollo/CustomApolloProvider";
import MainLoader from "../MainLoader/MainLoader";
import AiChatWidget from "../ai/AiChatWidget";

const MainWrapper = styled("div")(() => ({
  display: "flex",
  minHeight: "100vh",
  width: "100%",
}));

const PageWrapper = styled("div")(() => ({
  display: "flex",
  flexGrow: 1,
  flexDirection: "column",
  zIndex: 1,
  width: "100%",
  backgroundColor: "transparent",
}));

function LayoutHOC({ children }) {
  const { isError } = useApolloContext();
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const [bytoken] = useLazyQuery(TOKENBYUSER, { fetchPolicy: "network-only" });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const customizer = useSelector(state => state.customizer);
  const userData = useSelector(state => state.reducer.userData);
  const theme = useTheme();
  const ShowNav = useMemo(
    () =>
      location.pathname === "/" ||
      location.pathname.includes("forgetPassword") ||
      location.pathname.includes("register") ||
      location.pathname.includes("preSignUp") ||
      location.pathname.includes("resendVerify") ||
      location.pathname === "verify" ||
      location.pathname.includes("forgot") ||
      location.pathname.includes("auth/login") ||
      location.pathname.includes("changepassword") ||
      location.pathname.includes("project-config") ||
      loading,
    [location.pathname, loading],
  );

  const callInUseEffect = async token => {
    if (token !== null && token !== undefined) {
      const currentPath = window.location.pathname;
      const { data } = await bytoken({
        variables: {
          token,
        },
      });
      if (!data?.tokenByUserData?.user) {
        removeToken();
        navigate("/");
        setLoading(false);
        return;
      }
      await dispatch(
        loginUser(
          {
            ...data?.tokenByUserData?.user,
            subscription: data?.tokenByUserData?.subscription,
            subscriptionCredits: data?.tokenByUserData?.subscriptionCredits,
          } || {},
        ),
      );

      if (data?.tokenByUserData?.user?.userTheme) {
        dispatch(setThemeConfig(data?.tokenByUserData?.user?.userTheme || {}));
      }
      if (currentPath === "/" || currentPath === "/login") {
        navigate(data?.tokenByUserData?.isCreateProject ? "/dashboard" : "/project-config");
      }
    } else {
      console.log("token not found");
    }
    setLoading(false);
  };

  useEffect(() => {
    const token = recoverSession("accessToken");

    if (location.pathname.includes("preSignUp")) {
      setLoading(false);
      return;
    }

    if (!token) {
      deleteSession();
      setLoading(false);
    }
    if (token !== null && token !== undefined) {
      callInUseEffect(token);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (isError) {
      setLoading(false);
      navigate("/");
    }
  }, [isError]);

  if (loading) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "calc(100vh - 100px)" }}>
        <MainLoader message="Loading..." />
      </Box>
    );
  }

  return (
    <>
      <MainWrapper>
        {!ShowNav && userData?.email && !customizer?.isHorizontal && <Sidebar />}
        <PageWrapper
          className="page-wrapper"
          sx={{
            ...(customizer?.isCollapse &&
              !ShowNav && {
                [theme.breakpoints.up("lg")]: {
                  ml: `${customizer.MiniSidebarWidth}px`,
                },
              }),
            "& .MuiContainer-root": {
              "@media screen and (min-width: 1900px)": { minWidth: "1600px" },
              "@media screen and (min-width: 2500px)": { minWidth: "2250px" },
            },
          }}
        >
          {!ShowNav && userData?.email && (
            <>
              {customizer?.isHorizontal ? <HorizontalHeader /> : <Header />}
              {customizer?.isHorizontal && <Navigation />}
              <Customizer />
            </>
          )}
          <Container
            sx={{
              maxWidth: !customizer?.isLayout === "boxed" ? "lg" : "100%!important",
              p: "0px !important",
            }}
          >
            <Box sx={{ minHeight: "calc(100vh - 170px)" }}>{children}</Box>
          </Container>
          {!ShowNav && userData?.email && <AiChatWidget />}
        </PageWrapper>
      </MainWrapper>
    </>
  );
}

export default memo(LayoutHOC);
